import styled from 'styled-components'

import { theme } from 'styles/theme'

const { space } = theme

export const Success = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${space['spacing-md']};
`

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 200px;

  img {
    width: 100%;
    height: auto;
  }
`
